import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CampusLessonDiagnostic, LearningDataAPI } from '../api/LearningDataAPI.js';
import { CampusLesson } from './CampusLesson.js';

@Entity()
export class CampusLastVisited extends MongoEntity {
  static override _class = 'CampusLastVisited';
  static override _collectionName = 'campus-last-visited';

  static override resolveID(entity: CampusLastVisited) {
    return entity.userID ?? A.getGloballyUniqueID();
  }

  @Field(() => [CampusLessonDiagnostic], {
    resolve: function (this: CampusLastVisited) {
      return async (gqlFields: BaseQLSelectionSet<CampusLessonDiagnostic>) => {
        return LearningDataAPI.getDiagnosticForLessons(this.userID ?? '', this.lessonIDs ?? [])(gqlFields) as Promise<
          CampusLessonDiagnostic[]
        >;
      };
    },
  })
  diagnostics: Maybe<CampusLessonDiagnostic[]>;

  getDiagnosticForLessonID(lessonID: string) {
    return this.diagnostics?.find(d => d.lessonID === lessonID);
  }

  @Field(() => [String])
  lessonIDs: Maybe<string[]>;

  @DataLoadedField(() => [CampusLesson], ({ lessonIDs }) => lessonIDs ?? [])
  lessons: Maybe<CampusLesson[]>;

  @Field(() => String)
  userID: Maybe<string>;
}
